module.exports = __webpack_public_path__ + "static/media/resident.c3b9e730.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resident.jpg
// module id = 254
// module chunks = 0